// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a4de35b","453":"506f201d","732":"5c3565f8","952":"5354a117","977":"ba4501c3"}[chunkId] + ".chunk.js";
};